import { apiSpaceUrl } from "utils/urls";

import axios from "axios";

export const getManuscriptList = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("manuscript", spaceUuid), { params: params });
    return data;
};

export const getManuscript = async (spaceUuid, manuscriptId) => {
    const { data } = await axios.get(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}`);
    return data;
};

export const getManuscriptTree = async (spaceUuid, manuscriptId) => {
    const { data } = await axios.get(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/tree`);
    return data;
};

export const getManuscriptSearch = async (spaceUuid, manuscriptId, params) => {
    const { data } = await axios.get(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/search`, {
        params,
    });
    return data;
};

export const getManuscriptDocument = async (spaceUuid, manuscriptId, nodeId) => {
    const { data } = await axios.get(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/documents/${nodeId}`);
    return data;
};

export const getLatestManuscriptCompile = async (spaceUuid, manuscriptId) => {
    try {
        const { data } = await axios.get(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/job/latest`, {
            params: { job_type: "compile" },
        });
        return data;
    } catch (error) {
        if (error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};

export const getLatestSuccessfulManuscriptCompile = async (spaceUuid, manuscriptId) => {
    try {
        const { data } = await axios.get(
            apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/job/latest-successful`,
            {
                params: { job_type: "compile" },
            },
        );
        return data;
    } catch (error) {
        if (error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};

export const getLatestManuscriptJob = async (spaceUuid, manuscriptId, params) => {
    try {
        const { data } = await axios.get(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/job/latest`, {
            params,
        });
        return data;
    } catch (error) {
        if (error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};

export const getManuscriptHistory = async (spaceUuid, manuscriptId) => {
    const { data } = await axios.get(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/history`);
    return data;
};

export const getManuscriptReviews = async (spaceUuid, manuscriptId) => {
    const { data } = await axios.get(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/reviews`);
    return data;
};

export const downloadManuscriptSourceZip = async (spaceUuid, manuscriptId) => {
    const response = await axios.get(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/source-zip`, {
        responseType: "blob",
    });
    return response;
};

export const getManuscriptTemplateList = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("manuscriptTemplate", spaceUuid), {
        params: params,
    });
    return data;
};

export const postManuscript = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("manuscript", spaceUuid), body);
    return data;
};

export const postManuscriptTemplateGeneration = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("manuscript", spaceUuid) + `/template-generation`, body, {
        headers: body instanceof FormData ? { "Content-Type": "multipart/form-data" } : undefined,
    });
    return data;
};

export const patchManuscript = async (spaceUuid, body) => {
    const { data } = await axios.patch(apiSpaceUrl("manuscript", spaceUuid) + `/${body.id}`, body);
    return data;
};

export const patchManuscriptSettings = async (spaceUuid, manuscriptId, body) => {
    const { data } = await axios.patch(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/settings`, body);
    return data;
};

export const postManuscriptNode = async (spaceUuid, manuscriptId, body) => {
    const { data } = await axios.post(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/nodes`, body, {
        headers: body instanceof FormData ? { "Content-Type": "multipart/form-data" } : undefined,
    });
    return data;
};

export const postManuscriptFigureUrl = async (spaceUuid, manuscriptId, body) => {
    const { data } = await axios.post(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/figure-url`, body);
    return data;
};

export const patchManuscriptNode = async (spaceUuid, manuscriptId, nodeId, body) => {
    const { data } = await axios.patch(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/nodes/${nodeId}`, body);
    return data;
};

export const deleteManuscriptNode = async (spaceUuid, manuscriptId, nodeId) => {
    const { data } = await axios.delete(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/nodes/${nodeId}`);
    return data;
};

export const patchManuscriptDocument = async (spaceUuid, manuscriptId, nodeId, body) => {
    const { data } = await axios.patch(
        apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/documents/${nodeId}`,
        body,
    );
    return data;
};

export const postManuscriptCompile = async (spaceUuid, manuscriptId) => {
    const { data } = await axios.post(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/compile`);
    return data;
};

export const postManuscriptReview = async (spaceUuid, manuscriptId, body) => {
    const { data } = await axios.post(apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/reviews`, body);
    return data;
};

export const postManuscriptReviewMessage = async (spaceUuid, manuscriptId, threadId, body) => {
    const { data } = await axios.post(
        apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/reviews/${threadId}/messages`,
        body,
    );
    return data;
};

export const postManuscriptReviewResolve = async (spaceUuid, manuscriptId, threadId) => {
    const { data } = await axios.post(
        apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/reviews/${threadId}/resolve`,
    );
    return data;
};

export const postManuscriptReviewReopen = async (spaceUuid, manuscriptId, threadId) => {
    const { data } = await axios.post(
        apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/reviews/${threadId}/reopen`,
    );
    return data;
};

export const postManuscriptHistoryRestore = async (spaceUuid, manuscriptId, revisionId) => {
    const { data } = await axios.post(
        apiSpaceUrl("manuscript", spaceUuid) + `/${manuscriptId}/history/${revisionId}/restore`,
    );
    return data;
};

export const deleteBulkManuscript = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("manuscript", spaceUuid) + `/bulk-delete`, { data: body });
    return data;
};
